import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputMaskModule } from 'primeng/inputmask';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TabViewModule } from 'primeng/tabview';
import { ToastModule } from 'primeng/toast';
import { PasswordUpdateModule } from 'src/app/components/password-update/password-update.module';
import { AppTableModule } from 'src/app/components/table/app-table.module';
import { UserFormModule } from 'src/app/components/user-form/user-form.module';
import { AccessLookerComponent } from './access-looker/access-looker.component';
import { EmailSignatureComponent } from './email-signature/email-signature.component';
import { SettingsRoutingModule } from './settings-routing.module';
import { SettingsComponent } from './settings.component';
import { DbUserCreateModalComponent } from './system-users/database-users/db-user-create-modal/db-user-create-modal.component';
import { DbUserPasswordModalComponent } from './system-users/database-users/db-user-password-modal/db-user-password-modal.component';
import { DbUserPermissionsModalComponent } from './system-users/database-users/db-user-permissions-modal/db-user-permissions-modal.component';
import { PasswordUpdateModalComponent } from './system-users/password-update-modal/password-update-modal.component';
import { SystemUsersComponent } from './system-users/system-users.component';
import { UserFormModalComponent } from './system-users/user-form-modal/user-form-modal.component';

@NgModule({
  declarations: [
    SettingsComponent,
    SystemUsersComponent,
    PasswordUpdateModalComponent,
    UserFormModalComponent,
    AccessLookerComponent,
    EmailSignatureComponent,
    DbUserCreateModalComponent,
    DbUserPasswordModalComponent,
    DbUserPermissionsModalComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InputMaskModule,
    UserFormModule,
    PasswordUpdateModule,
    AppTableModule,
    ButtonModule,
    CheckboxModule,
    ConfirmDialogModule,
    InputTextModule,
    MessageModule,
    SelectButtonModule,
    TabViewModule,
    ToastModule,
    SettingsRoutingModule
  ]
})
export class SettingsModule {}
